export function getMaximumDate(): string {
  const now = new Date()
  const minimumAge = 16
  now.setFullYear(now.getFullYear() - minimumAge)
  return now.toISOString().split('T')[0]
}
